import React, { useState, useEffect } from 'react'
import {
  ButtonHLPure,
  TextAreaHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from '../../../pures';
import { Grid } from '@material-ui/core';
import { profileIconDefault } from '../../../../assets/logos/icons';
import './user-administration-disable-user.view.css';
import { useTranslation } from 'react-i18next';

const UserAdministrationDisableUserView = ({
  hideShowDetails,
  selectedUser,
  saveStatusForUser,
  token,
  showDetailComponent,
  toggleShowDetailComponent,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
}) => {
  const { t } = useTranslation();
  const [comments, setComments] = useState('');
  const [openCompletedModal, setOpenCompletedModal] = useState(false)

  useEffect(() => {
    setOpenCompletedModal(showCompletedRequesting)
  }, [showCompletedRequesting])

  const handleChangeComments = (e) => {
    setComments(e.target.value);
  };

  const handleSave = () => {
    const body = {
      email: selectedUser.email,
      status: !selectedUser.active,
      comments: comments,
    };

    saveStatusForUser(token, body);
  };

  return (
    <div className='userAdministrationDisableUserView-wrapper'>
      <>
        <header className='userAdministrationDisableUserView-header'>
          <SubtitlePageHLPure
            subtitle={
              selectedUser.firstName !== '' ||
                (selectedUser.firstName !== null &&
                  selectedUser.firstLastName !== '') ||
                selectedUser.secondLastName !== ''
                ? `${t('userAdministrationDisableUserView.title.disable.to')} ${selectedUser.name}`
                : t('userAdministrationDisableUserView.title.disable.user')
            }
            imgProfile={profileIconDefault}
            profileImg={imgProfileSubtitle}
            tooltipShow
            informationIcon={false}
            justShowImg
            openTooltipDescription={false}
          />
        </header>
        <section className='userAdministrationDisableUserView-body'>
          <div className='userAdministrationDisableUserView-form'>
            <div className='userAdministrationDisableUserView-textAreaHLPure'>
              <TextAreaHLPure
                labelTextArea={
                  selectedUser.active
                    ? `${t(
                      'digitalContractDashboard.questionnaires.disableReason'
                    )} * ` +
                    '' +
                    selectedUser.name
                    : t('userAdministrationDisableUserView.reason.enabling') +
                    '' +
                    selectedUser.name
                }
                valueTextData={comments}
                handleChangeTextArea={(e) => handleChangeComments(e)}
              />
            </div>
          </div>
          <div className='userAdministrationDisableUserView-btnGroup'>
            <div className='userAdministrationDisableUserView-spaceBtns'>
              <ButtonHLPure
                nameBtn={t('button.return')}
                onClickBtn={
                  showDetailComponent
                    ? toggleShowDetailComponent
                    : hideShowDetails
                }
              />
            </div>
            <ButtonHLPure
              primary
              nameBtn={
                selectedUser.active
                  ? t('userAdministrationDisableUserView.btn.disable')
                  : t('userAdministrationDisableUserView.btn.enable')
              }
              onClickBtn={handleSave}
            />
          </div>
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            showCompletedRequesting={openCompletedModal}
            toggleCompletedRequesting={() => setOpenCompletedModal(false)}
            showErrorRequesting={showErrorRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            message={message}
          />
        </section>
      </>
    </div>
  );
};

export default UserAdministrationDisableUserView;
